<template>
  <div class="h-ct-root">
    <img src="@/assets/home/contact/img_home_contact_img_left.png" class="h-ct-img-left"/>
    <img src="@/assets/home/contact/img_home_contact_img_right.png" class="h-ct-img-right hidden-md-and-down"/>
    <el-row class="width-100" justify="center">
      <el-col :md="10" :span="AppConfig.span">
        <div class="h-ct-item">
            <span class="h-ct-title hidden-md-and-down">
              荧辉科技，为您护航
            </span>
          <span class="h-ct-title-phone hidden-md-and-up">
              荧辉科技，为您护航
            </span>
          <span class="h-ct-text margin-top-20 hidden-md-and-down">
              专家团队，为您快速维护信用问题
            </span>
          <span class="h-ct-text-phone margin-top-20 hidden-md-and-up">
              专家团队，为您快速维护信用问题
            </span>
          <div class="h-ct-btn-div margin-top-30">
            <span class="h-ct-btn-left margin-right-10" @click="onBtnClick()">免费咨询</span>
            <span class="h-ct-btn-right margin-left-10" @click="onBtnClick()">联系我们</span>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script lang="ts" setup>
import {AppConfig} from "@/config";
import {isShowQrCodeDialog} from "@/views/data/CommonData";

const onBtnClick = () => {
  isShowQrCodeDialog.value = true
}
</script>

<style scoped>
.h-ct-root {
  width: 100%;
  height: 350px;
  background-color: #eef4fe;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
}

.h-ct-img-left {
  position: absolute;
  left: 0;
  bottom: 0;
  width: 400px;
}

.h-ct-img-right {
  position: absolute;
  top: 0;
  right: 0;
  width: 400px;
}

.h-ct-title {
  font-size: 40px;
  color: #2f2f2f;
  font-weight: bold;
}

.h-ct-title-phone {
  font-size: 18px;
  color: #2f2f2f;
  font-weight: bold;
}

.h-ct-text {
  font-size: 18px;
  color: #444444;
}

.h-ct-text-phone {
  font-size: 15px;
  color: #444444;
}

.h-ct-item {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.h-ct-btn-div {
  display: flex;
  justify-content: center;
  align-items: center;
}

.h-ct-btn-left {
  background-color: #1b57ec;
  border-radius: 10px;
  height: 55px;
  width: 155px;
  color: #ffffff;
  font-size: 15px;
  font-weight: bold;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.h-ct-btn-right {
  background-color: #ffffff;
  border-radius: 10px;
  height: 55px;
  width: 155px;
  color: #1b57ec;
  border: 1px solid #1b57ec;
  font-size: 15px;
  font-weight: bold;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
</style>
